// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608040558/js/" + chunkId + "." + {"44":"41969656","225":"c9fa56c3","481":"e7f22582","486":"471e7f95","770":"ea5927a2"}[chunkId] + ".0.4525598471713309.chunk.js";
};